import {
  OAuthModuleConfig as LibOAuthModuleConfig,
  OAuthResourceServerConfig as LibOAuthResourceServerConfig
} from 'angular-oauth2-oidc';

export abstract class OAuthResourceServerConfig extends LibOAuthResourceServerConfig {
  /**
   * Determines whether to add the value of the currently impersonated and signed in MRI Client ID
   * as a header to the requests made to the resource server.
   *
   * Note: use the `allowedUrls` or `customUrlValidation` to define the url namespace
   * that makes up your resource server api
   *
   * @default true
   */
  abstract sendClientId?: boolean;

  /**
   * The name of the header to send the impersonated MRI Client ID.
   *
   * @default X-Impersonated-MriClientId
   */
  abstract impersonatedClientIdHeader?: string;

  /**
   * The name of the header to send the signed in MRI Client ID.
   *
   * @default X-Current-MriClientId
   */
  abstract signedInClientIdHeader?: string;
}

export abstract class OAuthModuleConfig implements LibOAuthModuleConfig {
  abstract resourceServer: OAuthResourceServerConfig;
}
